import { classroomAttendanceActionTypes } from 'src/store/actions';
import { AttendanceDetailsState } from '../initial.state';

const ClassroomAttendanceReducer = (state = new AttendanceDetailsState(), { type, payload }) => {
  switch (type) {
    case classroomAttendanceActionTypes.GET_CLASS_ATTENDANCE_DETAILS:
      return { ...state, classroomAttendanceData: payload.data };

    case classroomAttendanceActionTypes.GET_STUDENTS_ATTENDANCE_DETAILS:
      return { ...state, studentsAttendanceData: payload.data };

    case classroomAttendanceActionTypes.STUDENTS_LIST_SUCCESS:
      return { ...state, studentsDetails: payload.data };
    default:
      return state;
  }
};

export { ClassroomAttendanceReducer };
